import request from '@/utils/request'
import qs from 'qs'

export function login(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}

export function loginBySmsCode(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/loginBySmsCode',
        method: 'post',
        data
    })
}

export function dispatch(data) {
    data = qs.stringify(data)
    console.log(data)
    return request({
        url: '/user/dispatch',
        method: 'post',
        data
    })
}

export function updatePassword(data) {
    data = qs.stringify(data)
    console.log(data)
    return request({
        url: '/user/updatePassword',
        method: 'post',
        data
    })
}

export function getUserList(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/getUserList',
        method: 'post',
        data
    })
}

export function addUser(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/addUser',
        method: 'post',
        data
    })
}

export function deleteUser(data) {
    return request({
        url: '/user/deleteUser',
        method: 'post',
        requestBody: 'body',
        loading: true,
        data: data
    })
}

export function importUser(data) {
    return request({
        url: '/user/importUser',
        method: 'post',
        requestBody: 'body',
        loading: true,
        data: data
    })
}

export function updateUser(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/updateUser',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js